import { useTranslations } from '@vocab/react';
import { Button, Actions } from 'braid-design-system';
import React from 'react';
import { useDispatch } from 'react-redux';

import { CardAction } from 'src/components/Card/CardAction/CardAction';
import { CAREER_HISTORY } from 'src/components/Router';
import { usePage } from 'src/components/Router/usePage';
import { EDIT } from 'src/consts';
import { analyticsClient } from 'src/modules/analytics';
import { yearsOfExperienceEditClicked } from 'src/modules/analytics/yearsOfExperience/actionCreators';
import { useQuery } from 'src/modules/apollo';
import { useAppConfig } from 'src/modules/appConfig';
import { GetYearsOfExperienceDocument } from 'src/types/graphql';

import translations from './.vocab';

const RoleCardAction = ({
  isEmpty,
  actionText,
}: {
  isEmpty: boolean;
  actionText: string;
}) => (
  <CardAction
    card={CAREER_HISTORY}
    mode={EDIT}
    data={{ automation: 'career-history-add' }}
    actionText={actionText}
    isEmpty={isEmpty}
    onClick={() => {
      analyticsClient.cardOpened({
        currentPageSection: 'career history',
        currentPageSectionState: 'add',
      });
    }}
  />
);

export const ReadCareerHistoryCardAction = ({
  isEmpty,
  openYearsOfExperienceDialog,
}: {
  isEmpty: boolean;
  openYearsOfExperienceDialog: () => void;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslations(translations);
  const { showFeature, language } = useAppConfig();
  const page = usePage();
  const shouldNotShowTotalYearsExperience =
    !showFeature('total-years-experience') || page === 'create-resume-page';
  const { data, loading, error } = useQuery(GetYearsOfExperienceDocument, {
    skip: shouldNotShowTotalYearsExperience,
    variables: { languageCode: language },
  });

  if (shouldNotShowTotalYearsExperience) {
    return <RoleCardAction isEmpty={isEmpty} actionText={t('Add role')} />;
  }

  const yearsOfExperience = loading ? null : data?.viewer?.yearsOfExperience;

  if (!loading && !error && yearsOfExperience?.option?.id) {
    return <RoleCardAction isEmpty={isEmpty} actionText={t('Add role')} />;
  }

  return (
    <Actions>
      <Button
        tone="formAccent"
        variant="ghost"
        onClick={() => {
          openYearsOfExperienceDialog();
          dispatch(
            yearsOfExperienceEditClicked({
              currentPageSectionState: 'add',
            }),
          );
        }}
        data={{ automation: 'years-of-experience-update-button' }}
      >
        {t('Update years of experience')}
      </Button>
    </Actions>
  );
};
